import { useState, useCallback } from 'react';
import { ALL_PROJECTS_VALUE } from '../types';

export const useProjectSelection = () => {
  const [selectedProjectId, setSelectedProjectId] = useState<string[]>([]);

  const handleProjectChange = useCallback((value: any) => {
    if (value && 'value' in value) {
      if (value.value === ALL_PROJECTS_VALUE) {
        setSelectedProjectId([]); // null means show all projects
      } else {
        setSelectedProjectId([value.value] as string[]); // if a specific project is selected, use array with just that project ID
      }
    } else {
      setSelectedProjectId([]); // cleared = show all projects
    }
  }, []);

  const resetProjectSelection = useCallback(() => {
    setSelectedProjectId([]);
  }, []);

  return {
    selectedProjectId,
    handleProjectChange,
    setSelectedProjectId,
    resetProjectSelection,
  };
};
